import React, {
    useEffect,
    useState,
    useCallback,
} from 'react';
import Header from './Header';
import Footer from './Footer';
import RouteContent from '../route/RouteContent';

import {
   createMuiTheme,
   responsiveFontSizes,
   MuiThemeProvider,
   Container
} from '@material-ui/core'
import Speech from 'speak-tts'
import {ObjectDetectRefContext } from '../core/services/ObjectDetectRefService'
import { checkBrowser } from '../core/shared/commFunSet';
import { data } from '../core/models/cocoDataSet'

//
// IMPORT ZONE
//

let theme = createMuiTheme()
theme = responsiveFontSizes(theme)

const  MainContent = () => {
    const [ speaker, setSpeaker ] = useState({})
    const [ browserVoiceList, setBrowserVocieList ] = useState([])
    const [ currentVoice, setCurrentVoice ] = useState([])
    const [ currentLang, setCurrentLang ] = useState([])
    // 2021-06-28
    const [ cocoDataSetTts , setCocoDataSetTts ] = useState(JSON.parse(JSON.stringify(data)))

    const initSpeech = useCallback( () => {
        const ttsSpeech = new Speech();
        ttsSpeech.init({
          volume: 1,
          lang: 'zh-TW', // 這個要加入不然 default 會沒有發不出聲音
          rate: 1,
          pitch: 1,
          'splitSentences': true,
          listeners: {
            onvoiceschanged: (voices) => {
              // 實測 ios 手機進入這
              setBrowserVocieList(voices)
              setSpeaker(ttsSpeech)
            }
          }
        }).then( data => {
            setBrowserVocieList(data)
            
            if (!checkBrowser().includes('Safari')) {
                // 非 ios
                setCurrentLang(data.voices[data.voices.length  - 1].lang)
                setCurrentVoice(data.voices[data.voices.length  - 1].name)
                
                ttsSpeech.setLanguage(data.voices[data.voices.length - 1].lang)
                ttsSpeech.setVoice(data.voices[data.voices.length - 1].name)
            } else {
                // 是ios
                setCurrentLang(data.voices[data.voices.length - 2].lang)
                setCurrentVoice(data.voices[data.voices.length - 2].name)
                
                ttsSpeech.setLanguage(data.voices[data.voices.length - 2].lang)
                ttsSpeech.setVoice(data.voices[data.voices.length - 2].name)
            }
            setSpeaker(ttsSpeech)
        })
      }, [])

      
    // init speech
    useEffect(() => {
        initSpeech()
      }, [initSpeech])
      
    return (
        <>
        <MuiThemeProvider theme={theme}>
        <ObjectDetectRefContext.Provider 
          value={{ 
              speaker: speaker, 
              setSpeaker: setSpeaker, 
              browserVoiceList: browserVoiceList, 
              setBrowserVocieList: setBrowserVocieList,
              currentVoice: currentVoice,
              setCurrentVoice: setCurrentVoice,
              currentLang: currentLang,
              setCurrentLang: setCurrentLang,
              // 2021-06-28
              cocoDataSetTts: cocoDataSetTts,
              setCocoDataSetTts: setCocoDataSetTts
              }}>
            {/* Main Contern*/}
            <Header/>
            <Container 
              maxWidth="lg"
              style={{minHeight: '100vh', paddingBottom: '25px'}}
              >
              <RouteContent />
            </Container>
            <Footer />
        </ObjectDetectRefContext.Provider>
        </MuiThemeProvider>
        </>
    )
}

export default MainContent
